import ReadMoreToggle from '../../components/readmore.js';

// Initialize ReadMoreToggle component for bio pages
document.addEventListener('DOMContentLoaded', () => {
  new ReadMoreToggle();

  // Key Trainings modal
  const btn = document.getElementById('keyTrainingsBtn');
  const overlay = document.getElementById('keyTrainingsOverlay');
  const closeBtn = document.getElementById('keyTrainingsClose');

  if (btn && overlay && closeBtn) {
    const openModal = () => {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('is-visible'));
      btn.setAttribute('aria-expanded', 'true');
      closeBtn.focus();
    };

    const closeModal = () => {
      overlay.classList.remove('is-visible');
      overlay.addEventListener('transitionend', () => {
        overlay.hidden = true;
      }, { once: true });
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    };

    btn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });
  }
});
